class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => {
        if ((event.code || event.key || '').toUpperCase() !== 'ESCAPE') return;
        event.preventDefault();
        event.stopPropagation();
        this.close();
      }
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]')?.addEventListener(
      'click',
      this.close.bind(this)
    );
    this.querySelector('button[type="reset"]')?.addEventListener(
      'click',
      this.reset.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(this.summaryToggle);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close();
  }

  open(trigger = this.summaryToggle) {
    if (this.detailsContainer.hasAttribute('open')) return;
    this.activeElement = trigger;
    this.summaryToggle.setAttribute('aria-expanded', 'true');
    setScrollbarWidth();
    setHeaderBottomPosition();
    
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      
    this.detailsContainer.setAttribute('open', true);
    this.bodyClickTimer = setTimeout(() => document.body.addEventListener('click', this.onBodyClickEvent));
    document.body.classList.add('search-modal--open');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close() {
    if (!this.detailsContainer.hasAttribute('open')) return;
    clearTimeout(this.bodyClickTimer);
    this.summaryToggle.setAttribute('aria-expanded', 'false');
    removeTrapFocus();
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('search-modal--open');
    document.dispatchEvent(new CustomEvent('searchmodal:close'));
    const trigger = this.activeElement?.isConnected && !this.activeElement.closest('[inert]') ? this.activeElement : this.summaryToggle;
    trigger.focus({ preventScroll: true });
  }

  reset(event) {
    event.preventDefault();
    this.querySelector('input[type="search"]').value = '';
  }
}

customElements.define('search-modal', SearchModal);
